(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2655],{

/***/ 78298:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(91941);

__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;

var _createSvgIcon = _interopRequireDefault(__webpack_require__(64938));

var _jsxRuntime = __webpack_require__(85893);

var _default = (0, _createSvgIcon.default)( /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M17.77 3.77 16 2 6 12l10 10 1.77-1.77L9.54 12z"
}), 'ArrowBackIosNew');

exports.Z = _default;

/***/ }),

/***/ 30120:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _mui_system__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(61354);
/* harmony import */ var _className__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(18356);
/* harmony import */ var _styles__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(76281);




const defaultTheme = (0,_styles__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)();
const Box = (0,_mui_system__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
  defaultTheme,
  defaultClassName: 'MuiBox-root',
  generateClassName: _className__WEBPACK_IMPORTED_MODULE_2__/* ["default"].generate */ .Z.generate
});
 false ? 0 : void 0;
/* harmony default export */ __webpack_exports__["Z"] = (Box);

/***/ }),

/***/ 22843:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/checkout/ultimo-antojo",
      function () {
        return __webpack_require__(28043);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 28043:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ LastWhim; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/components/seo.tsx
var seo = __webpack_require__(39425);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/utils/index.ts + 3 modules
var utils = __webpack_require__(8881);
// EXTERNAL MODULE: ./node_modules/@apollo/client/react/hooks/useQuery.js
var useQuery = __webpack_require__(71641);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ./node_modules/@apollo/client/node_modules/graphql-tag/lib/index.js + 10 modules
var lib = __webpack_require__(68921);
;// CONCATENATED MODULE: ./src/queries/products/queries/lastWhimProducts.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query LastWhimProducts($params: LastWhimProductsParams!) {\n    lastWhimProducts(params: $params) {\n      price\n      activePrinciple\n      availability {\n        status\n        discountStock\n        stock\n      }\n      discount {\n        price\n        type\n        stockRestriction\n        dateRestriction\n        listPrice\n      }\n      quantity\n      concentration\n      imagesUrl\n      name\n      slug\n      thumbnailUrl\n      unit\n      format\n      uuid\n      isCheapestActivePrinciple\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var LastWhimProductsQuery = function() {
    return (0,lib/* gql */.Ps)(_templateObject());
};

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(47842);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/styled.js
var styled = __webpack_require__(13264);
;// CONCATENATED MODULE: ./src/screens/checkout/last-whim/styles.ts


var LastWhimContainer = (0,styled/* default */.Z)("div")(function(param) {
    var theme = param.theme;
    return (0,_define_property/* default */.Z)({
        width: "100%",
        display: "flex",
        flexDirection: "column",
        borderRadius: "10px",
        backgroundColor: "white",
        border: "1px solid #EAEAEA",
        overflow: "hidden",
        marginBottom: "160px"
    }, theme.breakpoints.up("md"), {
        marginBottom: 0
    });
});

// EXTERNAL MODULE: ./src/components/PageWrapper.tsx
var PageWrapper = __webpack_require__(73362);
// EXTERNAL MODULE: ./src/components/Header/SimpleHeader.tsx + 1 modules
var SimpleHeader = __webpack_require__(45629);
// EXTERNAL MODULE: ./src/screens/checkout/styles.ts
var styles = __webpack_require__(58055);
// EXTERNAL MODULE: ./src/screens/checkout/components/OrderSummary.tsx
var OrderSummary = __webpack_require__(42737);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/config/constants.ts
var constants = __webpack_require__(8002);
// EXTERNAL MODULE: ./src/hooks/useAuth.tsx + 3 modules
var useAuth = __webpack_require__(3638);
// EXTERNAL MODULE: ./src/hooks/useOrderState.tsx
var useOrderState = __webpack_require__(778);
// EXTERNAL MODULE: ./src/hooks/usePermissions.tsx + 1 modules
var usePermissions = __webpack_require__(18782);
// EXTERNAL MODULE: ./src/components/FreeDeliveryProgressCard.tsx + 1 modules
var FreeDeliveryProgressCard = __webpack_require__(29087);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(98788);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(45680);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Skeleton/Skeleton.js + 2 modules
var Skeleton = __webpack_require__(91655);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(29630);
;// CONCATENATED MODULE: ./src/screens/checkout/last-whim/components/LastWhimProductCard.styles.ts


var RootDiv = (0,styled/* default */.Z)("div")({
    display: "flex",
    gap: "8px",
    padding: "8px 16px",
    position: "relative",
    borderBottom: "1px solid #EAEAEA",
    alignItems: "center",
    "&:last-child": {
        borderBottom: "none"
    }
});
var SkeletonImg = (0,styled/* default */.Z)(Skeleton/* default */.Z)({
    width: "50px",
    height: "50px"
});
var ImgProduct = (0,styled/* default */.Z)("img")({
    height: "50px",
    width: "50px",
    cursor: "pointer",
    objectFit: "contain"
});
var InfoDiv = (0,styled/* default */.Z)("div")({
    flex: 1,
    display: "flex",
    flexDirection: "column",
    cursor: "pointer",
    minWidth: 0
});
var TitleTypography = (0,styled/* default */.Z)(Typography/* default */.Z)({
    fontSize: "14px",
    fontWeight: 500,
    lineHeight: "21px",
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis"
});
var DetailsTextTypography = (0,styled/* default */.Z)(Typography/* default */.Z)({
    fontSize: "12px",
    fontWeight: 400,
    letterSpacing: "0.4px",
    lineHeight: "18px",
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    color: "#757575"
});
var PriceContainer = (0,styled/* default */.Z)("div")({
    display: "flex",
    gap: "4px"
});
var PriceTypography = (0,styled/* default */.Z)(Typography/* default */.Z, {
    shouldForwardProp: function(prop) {
        return prop !== "isOldPrice";
    }
})(function(param) {
    var isOldPrice = param.isOldPrice, theme = param.theme;
    return {
        color: isOldPrice ? theme.palette.text.disabled : theme.palette.text.primary,
        fontSize: "14px",
        fontWeight: 500,
        lineHeight: "21px",
        textDecoration: isOldPrice ? "line-through" : "none"
    };
});

// EXTERNAL MODULE: ./src/screens/product/utils/extractExtraInfo.tsx
var extractExtraInfo = __webpack_require__(73724);
// EXTERNAL MODULE: ./src/screens/product/hooks/useUpdateQuantity.ts + 1 modules
var useUpdateQuantity = __webpack_require__(10830);
// EXTERNAL MODULE: ./src/config/environment.ts
var environment = __webpack_require__(60031);
// EXTERNAL MODULE: ./src/utils/formatters/CurrencyFormatter.ts
var CurrencyFormatter = __webpack_require__(23239);
// EXTERNAL MODULE: ./src/hooks/useSegment.ts
var useSegment = __webpack_require__(59945);
// EXTERNAL MODULE: ./src/components/Product/ProductQuantityActions.tsx + 1 modules
var ProductQuantityActions = __webpack_require__(29452);
// EXTERNAL MODULE: ./src/hooks/useAddProduct.tsx
var useAddProduct = __webpack_require__(59509);
// EXTERNAL MODULE: ./src/validators/Events/Product.ts
var Product = __webpack_require__(63475);
;// CONCATENATED MODULE: ./src/screens/checkout/last-whim/components/LastWhimProductCard.tsx
















var currencyFormatter = new CurrencyFormatter/* CurrencyFormatter */.J({
    fallback: environment/* NEXT_PUBLIC_NO_PRICE_FALLBACK */.uh
});
var defaultImage = "/assets/images/default.webp";
var LastWhimProductCard = function(param) {
    var product = param.product, loading = param.loading;
    var ref, ref1, ref2, ref3;
    var track = (0,useSegment/* useSegment */.K)().track;
    var router = (0,next_router.useRouter)();
    var ref4 = (0,useAddProduct/* useAddProduct */.h)({
        location: Product/* ProductInteractionLocation.LastWhim */.qv.LastWhim
    }), handleAddProductToCart = ref4.handleAddProduct, addProductToCartLoading = ref4.loading;
    var ref5 = (0,useUpdateQuantity/* useUpdateQuantity */.w)({
        product: product,
        price: product.price,
        location: Product/* ProductInteractionLocation.LastWhim */.qv.LastWhim
    }), addQuantity = ref5.addQuantity, subQuantity = ref5.subQuantity, quantity = ref5.quantity, MAX_AMOUNT = ref5.MAX_AMOUNT;
    var ref6 = (0,react.useState)(product === null || product === void 0 ? void 0 : (ref = product.imagesUrl) === null || ref === void 0 ? void 0 : ref[1]), imageUrl = ref6[0], setImageUrl = ref6[1];
    var hasDiscount = (product === null || product === void 0 ? void 0 : (ref1 = product.discount) === null || ref1 === void 0 ? void 0 : ref1.price) > 0;
    var ref7, ref8;
    var price = hasDiscount ? currencyFormatter.format((ref7 = product === null || product === void 0 ? void 0 : (ref2 = product.discount) === null || ref2 === void 0 ? void 0 : ref2.listPrice) !== null && ref7 !== void 0 ? ref7 : 0) : currencyFormatter.format((ref8 = product === null || product === void 0 ? void 0 : product.price) !== null && ref8 !== void 0 ? ref8 : 0);
    var ref9;
    var discountPrice = currencyFormatter.format((ref9 = product === null || product === void 0 ? void 0 : (ref3 = product.discount) === null || ref3 === void 0 ? void 0 : ref3.price) !== null && ref9 !== void 0 ? ref9 : 0);
    var handleAddProduct = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!(quantity === 0)) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        handleAddProductToCart({
                            puuid: product === null || product === void 0 ? void 0 : product.uuid,
                            product: product
                        })
                    ];
                case 1:
                    _state.sent();
                    _state.label = 2;
                case 2:
                    addQuantity();
                    return [
                        2
                    ];
            }
        });
    }), [
        handleAddProductToCart,
        product,
        addQuantity,
        quantity
    ]);
    var handleImageError = (0,react.useCallback)(function() {
        setImageUrl(defaultImage);
    }, [
        defaultImage
    ]);
    var handleClick = (0,react.useCallback)(function(elem) {
        var ref, ref1;
        var ref2, ref3, ref4;
        void track("product select", {
            id: product === null || product === void 0 ? void 0 : product.id,
            name: product === null || product === void 0 ? void 0 : product.name,
            brand: (ref2 = product === null || product === void 0 ? void 0 : product.makerBrand) !== null && ref2 !== void 0 ? ref2 : product === null || product === void 0 ? void 0 : product.laboratory,
            prescriptionType: (ref3 = product === null || product === void 0 ? void 0 : product.prescriptionType) !== null && ref3 !== void 0 ? ref3 : "null",
            category: (ref4 = product === null || product === void 0 ? void 0 : (ref = product.categories) === null || ref === void 0 ? void 0 : ref.map(function(c) {
                return c.name;
            }).join(", ")) !== null && ref4 !== void 0 ? ref4 : "null",
            search: "null",
            availability: product === null || product === void 0 ? void 0 : (ref1 = product.availability) === null || ref1 === void 0 ? void 0 : ref1.status,
            location: "lastWhim"
        });
        void router.push({
            pathname: "/producto/".concat(product.slug)
        });
    }, [
        product,
        router,
        track
    ]);
    (0,react.useEffect)(function syncronizeImage() {
        var ref;
        setImageUrl(product === null || product === void 0 ? void 0 : (ref = product.imagesUrl) === null || ref === void 0 ? void 0 : ref[1]);
    }, [
        product === null || product === void 0 ? void 0 : product.imagesUrl
    ]);
    if (loading) return /*#__PURE__*/ (0,jsx_runtime.jsx)(LastWhimProductCardSkeleton, {});
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(RootDiv, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ImgProduct, {
                src: imageUrl,
                onError: handleImageError,
                placeholder: "blur",
                onClick: function() {
                    return handleClick(product);
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(InfoDiv, {
                onClick: function() {
                    return handleClick(product);
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TitleTypography, {
                        children: product.name
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DetailsTextTypography, {
                        children: (0,extractExtraInfo/* extractExtraInfo */.UD)(product)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(PriceContainer, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(PriceTypography, {
                                isOldPrice: hasDiscount,
                                children: price
                            }),
                            hasDiscount && /*#__PURE__*/ (0,jsx_runtime.jsx)(PriceTypography, {
                                children: discountPrice
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductQuantityActions/* ProductQuantityActions */.O, {
                quantity: quantity,
                addQuantity: handleAddProduct,
                subQuantity: quantity > 0 ? subQuantity : undefined,
                MAX_AMOUNT: MAX_AMOUNT,
                loading: addProductToCartLoading
            })
        ]
    });
};
var LastWhimProductCardSkeleton = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(RootDiv, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SkeletonImg, {
                variant: "rectangular"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoDiv, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(TitleTypography, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                            variant: "text",
                            width: 300,
                            height: 21
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                            variant: "text",
                            width: 200,
                            height: 18
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                            variant: "text",
                            width: 100,
                            height: 21
                        })
                    ]
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/hooks/useWindowSize.ts
var useWindowSize = __webpack_require__(71096);
// EXTERNAL MODULE: ./src/screens/checkout/components/Title.tsx
var Title = __webpack_require__(79728);
// EXTERNAL MODULE: ./src/hooks/useEventTracking.tsx + 1 modules
var useEventTracking = __webpack_require__(66630);
// EXTERNAL MODULE: ./src/validators/Events/Screen.ts
var Screen = __webpack_require__(42101);
;// CONCATENATED MODULE: ./src/screens/checkout/last-whim/index.tsx























function LastWhimPage() {
    var ref;
    var isDesktop = (0,useWindowSize/* useWindowSize */.i)().isDesktop;
    var track = (0,useEventTracking/* useEventTracking */.A)().track;
    var router = (0,next_router.useRouter)();
    var ref1 = (0,useAuth/* useAuth */.a)(), user = ref1.appUser;
    var ref2 = (0,useOrderState/* useOrderState */.h)(), currentOrder = ref2.order;
    var userCan = (0,usePermissions/* usePermissions */.T)().userCan;
    var isLocalVendor = userCan("LOCAL_VENDOR");
    var ref3;
    var ref4 = (0,useQuery/* useQuery */.a)(LastWhimProductsQuery(), {
        variables: {
            params: {
                orderUuid: (ref3 = currentOrder === null || currentOrder === void 0 ? void 0 : currentOrder.uuid) !== null && ref3 !== void 0 ? ref3 : ""
            }
        },
        skip: !(currentOrder === null || currentOrder === void 0 ? void 0 : currentOrder.uuid)
    }), lastWhimData = ref4.data, lastWhimLoading = ref4.loading;
    void track(Screen/* ScreenEventType.ScreenLastWhimView */.O.ScreenLastWhimView);
    var subTotal = (0,react.useMemo)(function() {
        var ref;
        return currentOrder === null || currentOrder === void 0 ? void 0 : currentOrder.orderDetails.reduce(function(acc, curr) {
            var ref1;
            return acc + ((ref = (ref1 = curr.product.discount) === null || ref1 === void 0 ? void 0 : ref1.price) !== null && ref !== void 0 ? ref : curr.product.price) * curr.quantity;
        }, 0);
    }, [
        currentOrder === null || currentOrder === void 0 ? void 0 : currentOrder.orderDetails
    ]);
    var ref5 = (0,react.useMemo)(function() {
        var ref;
        var hasDeliveryCoupons = (user === null || user === void 0 ? void 0 : (ref = user.deliveryCoupons) === null || ref === void 0 ? void 0 : ref.count) > 0;
        if (isLocalVendor || subTotal >= constants/* FREE_SHIPPING_MIN_AMOUNT */.yP) {
            return {
                deliveryCost: 0,
                oldDeliveryCost: 0
            };
        }
        if (hasDeliveryCoupons) {
            return {
                deliveryCost: 0,
                oldDeliveryCost: constants/* DELIVERY_COST */.fI
            };
        }
        return {
            deliveryCost: constants/* DELIVERY_COST */.fI,
            oldDeliveryCost: constants/* DELIVERY_COST */.fI
        };
    }, [
        user === null || user === void 0 ? void 0 : (ref = user.deliveryCoupons) === null || ref === void 0 ? void 0 : ref.count,
        isLocalVendor,
        subTotal
    ]), deliveryCost = ref5.deliveryCost, oldDeliveryCost = ref5.oldDeliveryCost;
    var handleNext = (0,react.useCallback)(function() {
        void router.push((0,utils/* getRoute */.Bv)("checkoutDelivery").toString());
    }, [
        router
    ]);
    var lastWhimFilteredData = (0,react.useMemo)(function() {
        var ref;
        return lastWhimData === null || lastWhimData === void 0 ? void 0 : (ref = lastWhimData.lastWhimProducts) === null || ref === void 0 ? void 0 : ref.filter(function(product) {
            var ref;
            return [
                "AVAILABLE_24_HRS",
                "AVAILABLE"
            ].includes(product === null || product === void 0 ? void 0 : (ref = product.availability) === null || ref === void 0 ? void 0 : ref.status);
        });
    }, [
        lastWhimData === null || lastWhimData === void 0 ? void 0 : lastWhimData.lastWhimProducts,
        lastWhimLoading
    ]);
    var title = "\xbfOlvidaste algo?";
    var headerTitle = isDesktop ? "" : title;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PageWrapper/* BackgroundGlobalStyle */.m, {
                mobileColor: "gray"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SimpleHeader/* SimpleHeader */.A, {
                backButton: true,
                homeButton: isDesktop,
                title: headerTitle,
                color: "white"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PageWrapper/* PageWrapper */.F, {
                addHeaderPadding: false,
                disableMobilePadding: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* HorizontalContainer */.bp, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* CheckoutCardsContainer */.Q9, {
                            children: [
                                isDesktop && /*#__PURE__*/ (0,jsx_runtime.jsx)(Title/* CheckoutTitle */.A, {
                                    title: title
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(LastWhimContainer, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FreeDeliveryProgressCard/* FreeDeliveryProgressCard */.j, {
                                            subTotalCart: subTotal,
                                            loading: lastWhimLoading
                                        }),
                                        lastWhimLoading ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(LastWhimProductCardSkeleton, {}),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(LastWhimProductCardSkeleton, {}),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(LastWhimProductCardSkeleton, {})
                                            ]
                                        }) : lastWhimFilteredData === null || lastWhimFilteredData === void 0 ? void 0 : lastWhimFilteredData.map(function(product) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(LastWhimProductCard, {
                                                product: product
                                            }, product.id);
                                        })
                                    ]
                                })
                            ]
                        }),
                        isDesktop && /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderSummary/* OrderSummary */.H, {
                            variant: "desktop",
                            isDelivery: !isLocalVendor,
                            deliveryCost: deliveryCost,
                            oldDeliveryCost: oldDeliveryCost,
                            showInsurance: false,
                            showMekiCredits: false,
                            handleNext: handleNext,
                            buttonText: "Continuar al pago",
                            loading: lastWhimLoading
                        })
                    ]
                })
            }),
            !isDesktop && /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderSummary/* OrderSummary */.H, {
                variant: "fixed-bottom",
                isDelivery: !isLocalVendor,
                deliveryCost: deliveryCost,
                oldDeliveryCost: oldDeliveryCost,
                showInsurance: false,
                showMekiCredits: false,
                handleNext: handleNext,
                buttonText: "Continuar al pago",
                loading: lastWhimLoading
            })
        ]
    });
}

;// CONCATENATED MODULE: ./pages/checkout/ultimo-antojo/index.tsx



function LastWhim() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(seo/* SEOHead */.R, {
                title: "Meki \xb7 Ultimo antojo"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LastWhimPage, {})
        ]
    });
}


/***/ }),

/***/ 29087:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "j": function() { return /* binding */ FreeDeliveryProgressCard; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/config/constants.ts
var constants = __webpack_require__(8002);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Slider/Slider.js + 6 modules
var Slider = __webpack_require__(50394);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/styled.js
var styled = __webpack_require__(13264);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/LocalShippingOutlined.js
var LocalShippingOutlined = __webpack_require__(41865);
;// CONCATENATED MODULE: ./src/components/FreeDeliveryProgressCard.styles.ts



var RootDiv = (0,styled/* default */.Z)("div")({
    width: "100%",
    backgroundColor: "white",
    display: "flex",
    flexDirection: "column",
    gap: "8px",
    padding: "16px",
    borderBottom: "1px solid #e0e0e0"
});
var TopContainer = (0,styled/* default */.Z)("div")({
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "9px",
    color: "#15365F"
});
var TitleContainer = (0,styled/* default */.Z)("div")({
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: "4px"
});
var LocalShippingIcon = (0,styled/* default */.Z)(LocalShippingOutlined/* default */.Z)({
    fontSize: "16px"
});
var TitleTypography = (0,styled/* default */.Z)("div")({
    fontSize: "12px",
    fontWeight: "500",
    lineHeight: "16px",
    letterSpacing: "0.15px"
});
var PriceContainer = (0,styled/* default */.Z)("div")({
    display: "flex",
    flexDirection: "row",
    alignItems: "center"
});
var PriceTypography = (0,styled/* default */.Z)("div")({
    fontSize: "12px",
    fontWeight: "500",
    lineHeight: "16px",
    letterSpacing: "0.15px"
});
var MessageTypography = (0,styled/* default */.Z)("div")(function(param) {
    var theme = param.theme;
    return {
        fontSize: "12px",
        fontWeight: "400",
        lineHeight: "16px",
        letterSpacing: "0.15px",
        color: "#15365F",
        "& span": {
            fontWeight: "600",
            color: theme.palette.primary.main
        }
    };
});
var FreeDeliveryProgressSlider = (0,styled/* default */.Z)(Slider/* default */.ZP)(function(param) {
    var theme = param.theme;
    return {
        height: "4px",
        width: "98%",
        "& .MuiSlider-thumb": {
            height: "8px",
            width: "8px"
        },
        "&.Mui-disabled": {
            padding: "2px 0px",
            color: theme.palette.primary.main,
            "& .MuiSlider-track": {
                backgroundColor: theme.palette.primary.main
            }
        }
    };
});

// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Skeleton/Skeleton.js + 2 modules
var Skeleton = __webpack_require__(91655);
// EXTERNAL MODULE: ./src/utils/formatters/CurrencyFormatter.ts
var CurrencyFormatter = __webpack_require__(23239);
// EXTERNAL MODULE: ./src/hooks/useAuth.tsx + 3 modules
var useAuth = __webpack_require__(3638);
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/differenceInHours/index.js
var differenceInHours = __webpack_require__(80659);
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/differenceInMinutes/index.js
var differenceInMinutes = __webpack_require__(12647);
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/format/index.js + 23 modules
var format = __webpack_require__(83877);
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/parseISO/index.js
var parseISO = __webpack_require__(31807);
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/locale/es/index.js + 5 modules
var es = __webpack_require__(90535);
;// CONCATENATED MODULE: ./src/components/FreeDeliveryProgressCard.tsx








var currFormat = new CurrencyFormatter/* CurrencyFormatter */.J({
    fallback: "Gratis"
});
var GetDeliveryMessage = function(param) {
    var subTotalCart = param.subTotalCart, hasDeliveryCoupons = param.hasDeliveryCoupons, expirationDate = param.expirationDate;
    if (hasDeliveryCoupons && expirationDate) {
        var now = new Date();
        var hoursLeft = (0,differenceInHours/* default */.Z)(expirationDate, now);
        var minutesLeft = (0,differenceInMinutes/* default */.Z)(expirationDate, now);
        if (hoursLeft >= 24) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(MessageTypography, {
                children: [
                    "Hasta antes del",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: (0,format/* default */.Z)(expirationDate, "d 'de' MMMM 'a las' h:mm a", {
                            locale: es/* default */.Z
                        })
                    }),
                    " ",
                    "el despacho es ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: "GRATIS"
                    }),
                    "."
                ]
            });
        } else if (hoursLeft >= 2) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(MessageTypography, {
                children: [
                    "Dentro de las ",
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        children: [
                            "pr\xf3ximas ",
                            hoursLeft,
                            " horas"
                        ]
                    }),
                    " el despacho es",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: "GRATIS"
                    }),
                    "."
                ]
            });
        } else if (hoursLeft >= 1) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(MessageTypography, {
                children: [
                    "Dentro de la ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: "pr\xf3xima hora"
                    }),
                    " el despacho es",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: "GRATIS"
                    }),
                    "."
                ]
            });
        } else {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(MessageTypography, {
                children: [
                    "Dentro de los ",
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        children: [
                            "pr\xf3ximos ",
                            minutesLeft,
                            " minutos"
                        ]
                    }),
                    " el despacho es ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: "GRATIS"
                    }),
                    "."
                ]
            });
        }
    }
    if (subTotalCart < constants/* FREE_SHIPPING_MIN_AMOUNT */.yP) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(MessageTypography, {
            children: [
                "Agrega",
                " ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: currFormat.format(constants/* FREE_SHIPPING_MIN_AMOUNT */.yP - subTotalCart)
                }),
                " ",
                "para tener ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: "env\xedo gratis"
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(MessageTypography, {
        children: [
            "\xa1Aprovecha y ",
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                children: "agrega m\xe1s productos!"
            })
        ]
    });
};
var FreeDeliveryProgressCard = function(param) {
    var subTotalCart = param.subTotalCart, loading = param.loading;
    var ref, ref1;
    var appUser = (0,useAuth/* useAuth */.a)().appUser;
    var hasDeliveryCoupons = (appUser === null || appUser === void 0 ? void 0 : (ref = appUser.deliveryCoupons) === null || ref === void 0 ? void 0 : ref.count) > 0;
    var expirationDate = hasDeliveryCoupons ? (0,parseISO/* default */.Z)(appUser === null || appUser === void 0 ? void 0 : (ref1 = appUser.deliveryCoupons) === null || ref1 === void 0 ? void 0 : ref1.minExpirationDate) : null;
    var deliveryCost = hasDeliveryCoupons || subTotalCart >= constants/* FREE_SHIPPING_MIN_AMOUNT */.yP ? 0 : constants/* DELIVERY_COST */.fI;
    var deliveryProgress = hasDeliveryCoupons ? 100 : subTotalCart / constants/* FREE_SHIPPING_MIN_AMOUNT */.yP * 100;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(RootDiv, {
        children: loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
            height: "58px",
            width: "100%",
            variant: "rectangular"
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(TopContainer, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(TitleContainer, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(LocalShippingIcon, {
                                    sx: {
                                        fontSize: "18px"
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TitleTypography, {
                                    children: "Despacho"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PriceContainer, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PriceTypography, {
                                children: currFormat.format(deliveryCost)
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(FreeDeliveryProgressSlider, {
                    value: deliveryProgress,
                    size: "small",
                    disabled: true,
                    "aria-label": "Progreso para despacho gratis"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(GetDeliveryMessage, {
                    subTotalCart: subTotalCart,
                    hasDeliveryCoupons: hasDeliveryCoupons,
                    expirationDate: expirationDate
                })
            ]
        })
    });
};


/***/ }),

/***/ 29452:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "O": function() { return /* binding */ ProductQuantityActions; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/styled.js
var styled = __webpack_require__(13264);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/IconButton/IconButton.js + 1 modules
var IconButton = __webpack_require__(80562);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(29630);
;// CONCATENATED MODULE: ./src/components/Product/ProductQuantityActions.styles.ts


var RootDiv = (0,styled/* default */.Z)("div")({
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    gap: 14,
    alignItems: "center",
    backgroundColor: "#FFFFFF",
    border: "1px stroke #EAEAEA",
    boxShadow: "0px 0px 5px 0px #D9D9D9",
    borderRadius: "66px",
    maxHeight: "30px"
});
var CartProductCartActionsIconButton = (0,styled/* default */.Z)(IconButton/* default */.Z)({
    padding: 5,
    margin: 0,
    color: "rgb(16	100	177)",
    width: 30,
    height: 30
});
var CartProductCartActionsTypography = (0,styled/* default */.Z)(Typography/* default */.Z)({
    fontSize: 18,
    color: "#414046",
    margin: 0,
    maxWidth: 22,
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis"
});


// EXTERNAL MODULE: ./node_modules/@mui/icons-material/Delete.js
var Delete = __webpack_require__(41733);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/Add.js
var Add = __webpack_require__(96540);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/Remove.js
var Remove = __webpack_require__(94895);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/components/Product/ProductQuantityActions.tsx






function ProductQuantityActions(param) {
    var quantity = param.quantity, addQuantity = param.addQuantity, subQuantity = param.subQuantity, MAX_AMOUNT = param.MAX_AMOUNT, loading = param.loading;
    var handleAddQuantity = (0,react.useCallback)(function(event) {
        if (loading) return;
        addQuantity();
        event.stopPropagation();
        event.preventDefault();
    }, [
        addQuantity,
        loading
    ]);
    var disabled = loading || quantity >= MAX_AMOUNT;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(RootDiv, {
        onClick: function(event) {
            return event.stopPropagation();
        },
        children: [
            subQuantity && quantity > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CartProductCartActionsIconButton, {
                        style: quantity <= 1 ? {
                            border: "none"
                        } : {},
                        onClick: function(event) {
                            subQuantity();
                            event.stopPropagation();
                        },
                        children: quantity <= 1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Delete/* default */.Z, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Remove/* default */.Z, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CartProductCartActionsTypography, {
                        children: quantity
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CartProductCartActionsIconButton, {
                onClick: handleAddQuantity,
                disabled: disabled,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Add/* default */.Z, {})
            })
        ]
    });
}


/***/ }),

/***/ 8002:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Gr": function() { return /* binding */ FREE_SECOND_SHIPPING_MIN_AMOUNT; },
/* harmony export */   "Nd": function() { return /* binding */ GOOGLE_RATING; },
/* harmony export */   "fI": function() { return /* binding */ DELIVERY_COST; },
/* harmony export */   "qM": function() { return /* binding */ SECOND_DELIVERY_COST; },
/* harmony export */   "yP": function() { return /* binding */ FREE_SHIPPING_MIN_AMOUNT; }
/* harmony export */ });
var FREE_SHIPPING_MIN_AMOUNT = 35000;
var FREE_SECOND_SHIPPING_MIN_AMOUNT = 70000;
var DELIVERY_COST = 3490;
var SECOND_DELIVERY_COST = 990;
var GOOGLE_RATING = 4.8;


/***/ }),

/***/ 50139:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var h=__webpack_require__(67294),n=__webpack_require__(61688);function p(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}var q="function"===typeof Object.is?Object.is:p,r=n.useSyncExternalStore,t=h.useRef,u=h.useEffect,v=h.useMemo,w=h.useDebugValue;
exports.useSyncExternalStoreWithSelector=function(a,b,e,l,g){var c=t(null);if(null===c.current){var f={hasValue:!1,value:null};c.current=f}else f=c.current;c=v(function(){function a(a){if(!c){c=!0;d=a;a=l(a);if(void 0!==g&&f.hasValue){var b=f.value;if(g(b,a))return k=b}return k=a}b=k;if(q(d,a))return b;var e=l(a);if(void 0!==g&&g(b,e))return b;d=a;return k=e}var c=!1,d,k,m=void 0===e?null:e;return[function(){return a(b())},null===m?void 0:function(){return a(m())}]},[b,e,l,g]);var d=r(a,c[0],c[1]);
u(function(){f.hasValue=!0;f.value=d},[d]);w(d);return d};


/***/ }),

/***/ 52798:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(50139);
} else {}


/***/ }),

/***/ 64529:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Ue": function() { return /* binding */ create; }
});

// UNUSED EXPORTS: createStore, default, useStore

;// CONCATENATED MODULE: ./node_modules/zustand/esm/vanilla.mjs
const createStoreImpl = (createState) => {
  let state;
  const listeners = /* @__PURE__ */ new Set();
  const setState = (partial, replace) => {
    const nextState = typeof partial === "function" ? partial(state) : partial;
    if (!Object.is(nextState, state)) {
      const previousState = state;
      state = (replace != null ? replace : typeof nextState !== "object" || nextState === null) ? nextState : Object.assign({}, state, nextState);
      listeners.forEach((listener) => listener(state, previousState));
    }
  };
  const getState = () => state;
  const getInitialState = () => initialState;
  const subscribe = (listener) => {
    listeners.add(listener);
    return () => listeners.delete(listener);
  };
  const destroy = () => {
    if (( false ? 0 : void 0) !== "production") {
      console.warn(
        "[DEPRECATED] The `destroy` method will be unsupported in a future version. Instead use unsubscribe function returned by subscribe. Everything will be garbage-collected if store is garbage-collected."
      );
    }
    listeners.clear();
  };
  const api = { setState, getState, getInitialState, subscribe, destroy };
  const initialState = state = createState(setState, getState, api);
  return api;
};
const createStore = (createState) => createState ? createStoreImpl(createState) : createStoreImpl;
var vanilla = (createState) => {
  if (( false ? 0 : void 0) !== "production") {
    console.warn(
      "[DEPRECATED] Default export is deprecated. Instead use import { createStore } from 'zustand/vanilla'."
    );
  }
  return createStore(createState);
};



// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/use-sync-external-store/shim/with-selector.js
var with_selector = __webpack_require__(52798);
;// CONCATENATED MODULE: ./node_modules/zustand/esm/index.mjs





const { useDebugValue } = react;
const { useSyncExternalStoreWithSelector } = with_selector;
let didWarnAboutEqualityFn = false;
const identity = (arg) => arg;
function useStore(api, selector = identity, equalityFn) {
  if (( false ? 0 : void 0) !== "production" && equalityFn && !didWarnAboutEqualityFn) {
    console.warn(
      "[DEPRECATED] Use `createWithEqualityFn` instead of `create` or use `useStoreWithEqualityFn` instead of `useStore`. They can be imported from 'zustand/traditional'. https://github.com/pmndrs/zustand/discussions/1937"
    );
    didWarnAboutEqualityFn = true;
  }
  const slice = useSyncExternalStoreWithSelector(
    api.subscribe,
    api.getState,
    api.getServerState || api.getInitialState,
    selector,
    equalityFn
  );
  useDebugValue(slice);
  return slice;
}
const createImpl = (createState) => {
  if (( false ? 0 : void 0) !== "production" && typeof createState !== "function") {
    console.warn(
      "[DEPRECATED] Passing a vanilla store will be unsupported in a future version. Instead use `import { useStore } from 'zustand'`."
    );
  }
  const api = typeof createState === "function" ? createStore(createState) : createState;
  const useBoundStore = (selector, equalityFn) => useStore(api, selector, equalityFn);
  Object.assign(useBoundStore, api);
  return useBoundStore;
};
const create = (createState) => createState ? createImpl(createState) : createImpl;
var esm_react = (createState) => {
  if (( false ? 0 : void 0) !== "production") {
    console.warn(
      "[DEPRECATED] Default export is deprecated. Instead use `import { create } from 'zustand'`."
    );
  }
  return create(createState);
};




/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2962,4789,2510,9774,2888,179], function() { return __webpack_exec__(54961), __webpack_exec__(22843); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);